import React, { lazy } from "react";
import Page from "components/Page";
import { Props } from "./LockedGuarantees";

const LockedGuarantees = lazy(() => import("./LockedGuarantees"));

export default (props: Props) => (
  <Page>
    <LockedGuarantees {...props} />
  </Page>
);
